import PropTypes from 'prop-types';

export default PropTypes.shape({
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired
});



// WEBPACK FOOTER //
// ./src/utils/shapes/BikeType.js